import React from 'react'

export const Loading = () => {
  return (
    <div className="p-10 w-full col-span-full text-center dark:text-gray-100 dark:bg-gray-600 bg-gray-400 text-3xl animate-pulse rounded mt-3">
      Loading...
    </div>
  )
}
